import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, interval, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UpdateService {
	private _updateAvailable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public updateAvailable$: Observable<boolean> = this._updateAvailable.asObservable();
	public readonly delayForShowingUpdateBar = 5 * 60 * 1000;

	constructor(public updates: SwUpdate) {
		if (updates.isEnabled) {
			interval(30 * 1_000).subscribe(() => updates.checkForUpdate()
				.catch((error) => console.warn('Checking for an app update failed', error)));
		}
	}

	public checkForUpdates(): void {
		this.updates.versionUpdates.subscribe(event => {
			switch (event.type) {
				case 'VERSION_DETECTED':
					console.log(`Downloading new app version: ${event.version.hash}`);
					break;
				case 'VERSION_READY':
					console.log(`Current app version: ${event.currentVersion.hash}`);
					console.log(`New app version ready for use: ${event.latestVersion.hash}`);
					this._updateAvailable.next(true);
					break;
				case 'VERSION_INSTALLATION_FAILED':
					console.log(`Failed to install app version '${event.version.hash}': ${event.error}`);
					break;
			}
		});
	}

	public async update(): Promise<void> {
		try {
			await this.updates.activateUpdate();
		} catch (error) {
			console.error('Could not activate the new app version before reload:', error);
		}

		window.location.reload();
	}
}
